import { Link } from 'react-router-dom';
import styled from 'styled-components';

const NoneStyleLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    font-weight: inherit;
`;

export default NoneStyleLink;
